import { watchlist } from "@/mocks/animeData";

function Watchlist() {
  return (
    <section id="watchlist" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold tracking-widest text-secondary-700 uppercase">
            Weekly Picks
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
            本周暖心片单，照着看就对了
          </h2>
          <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-700">
            编辑部按不同场景配好了三套组合，每天该看什么不用再纠结。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {watchlist.map((w, idx) => (
            <article
              key={w.day}
              className="overflow-hidden rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={w.image}
                  alt={`${w.title} 治愈片单配图`}
                  className="h-full w-full object-cover"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700 backdrop-blur-sm">
                  {w.day}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                    {idx + 1}
                  </span>
                  <h3 className="font-heading text-lg text-foreground-950">
                    {w.title}
                  </h3>
                </div>
                <ul className="mt-3 space-y-1.5">
                  {w.picks.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-2 text-sm text-foreground-700"
                    >
                      <i className="ri-checkbox-circle-line text-primary-500"></i>
                      {p}
                    </li>
                  ))}
                </ul>
                <p className="mt-3 border-t border-background-200/70 pt-3 text-sm text-foreground-600">
                  {w.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Watchlist;